
import { OrdersList } from "@/components/crm/OrdersList";
import { AppSidebar } from "@/components/AppSidebar";
import { SidebarProvider, SidebarInset } from "@/components/ui/sidebar";
import { FixedPageHeader } from "@/components/ui/fixed-page-header";
import { PAGE_HEADERS } from "@/constants/page-headers";

export default function CrmOrders() {
  return (
    <SidebarProvider>
      <div className="min-h-screen flex w-full bg-background">
        <AppSidebar />
        <SidebarInset>
          <FixedPageHeader {...PAGE_HEADERS.crmOrders} />
          <div className="px-4 md:px-8 py-6 md:py-8 space-y-8" style={{ paddingTop: "8.5rem" }}>
            <div className="space-y-6 w-full">
              <OrdersList />
            </div>
          </div>
        </SidebarInset>
      </div>
    </SidebarProvider>
  );
}
